import { ImageElement } from "@redotech/redo-model/forge/marketing-signup-forge-types";
import { memo } from "react";
import ImageIcon from "../../arbiter-icon/image-01.svg";
import { Flex } from "../../flex";
import * as ImageCSS from "./form-image.module.css";
import { FormElementProps } from "./index";

export const FormImage = memo(function FormImage({
  element,
}: FormElementProps<ImageElement>) {
  return (
    <Flex w="full">
      {element.url !== "" ? (
        <img src={element.url} />
      ) : (
        <div className={ImageCSS.placeholder}>
          <ImageIcon />
          Add image
        </div>
      )}
    </Flex>
  );
});
